<div id="layout" class="f_col">
  <div class="scroll_wrapper resp_wrapper">
    <div class="resp_c-50 resp_scroll-wrapper_l" [class.fullHeight]="!api.userRole.isCustomer">
      @if(api.userRole.isWorker) {
        <app-view-deco-image class="mt_40 resp_maxSize_l" imageUrl="assets/bms.svg"></app-view-deco-image>
      } @else {
        <app-view-deco-image maxWidth="200px" *ngIf="api.userRole.isCustomer" class="mt_40" [imageUrl]="api.env.theme.logo"></app-view-deco-image>
        <app-view-deco-image maxWidth="200px" *ngIf="!api.userRole.isCustomer && !api.userRole.isKiosk" class="mt_40 resp_maxSize_l" [imageUrl]="api.env.theme.logo"></app-view-deco-image>
      }
      <div class="f_center resp_maxSize_l" *ngIf="api.userInfo">
        <app-snackbar *ngIf="!api.userRole.isCustomer && !api.userRole.isKiosk">{{api.userInfo.name + ' | ' + (('form.role.'+userRoles[api.userInfo?.role] | lowercase) | translate)}}</app-snackbar>
        <app-snackbar *ngIf="api.userRole.isCustomer">{{api.userInfo.name}}</app-snackbar>
        <pop-icon-button class="ml_10" icon="question-circle" label="help" (click)="api.openSupport()" [matTooltip]="'tooltip.support' | translate"></pop-icon-button>
      </div>
      <div class="mt_30 fullHeight" [class.fullHeight-noMobile]="api.userRole.isWorker">
        <ng-container *ngIf="api.userRole?.isCustomer">
          <app-slide-element leftIcon="passport" class="mt_10" (btnClicked)="cart.startApplication()" [matTooltip]="'tooltip.createRequests' | translate">{{('menu.createRequests.DYN.') | translate}}</app-slide-element>
          <div class="relative" >
            <app-slide-element leftIcon="arrow-right-arrow-left" class="mt_10" (btnClicked)="nav.to('trips')" [matTooltip]="'tooltip.trips' | translate">{{('trips.title') | translate}}</app-slide-element>
            <span *ngIf="hasUiPerm(UiPermission.IS_NUMBER_APPLICATION_VISIBLE)" class="length-application-span">{{request.allMyApplications.length}}</span>
          </div>
          <app-slide-element *ngIf="api.env.hasMultiPersonView" leftIcon="people-roof" class="mt_10" (btnClicked)="nav.to('people')" [matTooltip]="'tooltip.people' | translate">{{'dashboard.people.DYN.' | translate}}</app-slide-element>
        </ng-container>
        <div *ngIf="!api.userRole?.isCustomer" class="menu-container">
          <ng-container *ngIf="api.userRole.isWorker && api.hasPerm(api.perm.ALLOW_CREATE) && api.hasPerm(api.perm.ALLOW_CONSUME) && (!!api.devtoolFakePassport || api.isElectronApp)">
            <div class="flex gap_10 f_col fullWidth">
              <div class="flex gap_10 mb_20 fullWidth" *ngIf="form && !this.api.env.useGuichet">
                <app-checkbox-element
                class="fullWidth"
                [matTooltip]="'tooltip.arrivals' | translate"
                                (onChange)="scanDocument.changeConsume(ConsumeMode.ENTRY, true, form)"
                                [formGrp]="form"
                                [formCtrlName]="'entryConsume'"
                                [id]="'entry'"
                                [text]="'entry.consume'"></app-checkbox-element>
                <app-checkbox-element
                class="fullWidth"
                [matTooltip]="'tooltip.transit' | translate"
                                (onChange)="scanDocument.changeConsume(ConsumeMode.TRANSIT, true, form)"
                                [formGrp]="form"
                                [formCtrlName]="'transitConsume'"
                                [id]="'transit'"
                                [text]="'transit.consume'"></app-checkbox-element>
                <app-checkbox-element
                class="fullWidth"
                [matTooltip]="'tooltip.departures' | translate"
                                (onChange)="scanDocument.changeConsume(ConsumeMode.EXIT, true, form)"
                                [formGrp]="form"
                                [formCtrlName]="'exitConsume'"
                                [id]="'exit'"
                                [text]="'exit.consume'"></app-checkbox-element>
              </div>
            </div>
            <app-divider class="mb_10 fullWidth" orientation="horizontal" *ngIf="!this.api.env.useGuichet"></app-divider>
          </ng-container>
          <div class="dashboardBtn-container f_center f_col f_align_c" *ngIf="api.userRole.isKiosk">
            <app-view-deco-image *ngIf="api.userRole.isKiosk" maxWidth="220px" imageUrl="assets/logo-kiosk.svg" margin="none"></app-view-deco-image>
            <ng-container>
              <div class="dashboard-btn cursor-pointer mb_40" (click)="cart.startApplication(true)">
                <fa-icon icon="play"></fa-icon>
                {{'dashboard.kiosk.start' | translate}}</div>
            </ng-container>
          </div>
          <div class="dashboardBtn-container" *ngIf="!api.userRole.isKiosk">

            <ng-container *ngIf="previousIdApplication">
              <div class="dashboard-btn cursor-pointer" [shortcut]="ShortcutAction.BACKSPACE" (click)="goToPreviousApplication()" [matTooltip]="'tooltip.goLatest' | translate">
                <fa-icon icon="backward-step"></fa-icon>
                {{'global.goLatest' | translate}}</div>
            </ng-container>

            <ng-container *ngIf="scanDocument.consumeMode === ConsumeMode.EXIT && api.hasPerm(api.perm.ALLOW_CONSUME) && api.hasPerm(api.perm.ALLOW_CREATE)">
              <div class="dashboard-btn cursor-pointer" shortcut [shortcutNumList]="true" (click)="nav.to('admin-request-create', undefined, {queryParams: {fromRoute: 'dashboard'}})" [matTooltip]="'tooltip.exitRegister' | translate">
                <fa-icon icon="arrow-right-from-bracket"></fa-icon>
                {{'exit.register' | translate}}</div>
            </ng-container>
            <ng-container *ngIf="scanDocument.consumeMode === ConsumeMode.TRANSIT && api.hasPerm(api.perm.ALLOW_CONSUME) && api.hasPerm(api.perm.ALLOW_CREATE)">
              <div class="dashboard-btn cursor-pointer" shortcut [shortcutNumList]="true" (click)="cart.startApplication(true)" [matTooltip]="'tooltip.transitRegister' | translate">
                <fa-icon icon="arrows-turn-to-dots"></fa-icon>
                {{'transit.register' | translate}}</div>
            </ng-container>
            <ng-container *ngIf="(scanDocument.consumeMode === ConsumeMode.ENTRY && api.hasPerm(api.perm.ALLOW_CONSUME) && api.hasPerm(api.perm.ALLOW_CREATE)) || (api.env.recordPaymentWorkerPass && hasUiPerm(UiPermission.SHOW_ENTRY_REGISTER_BTN))">
              <div class="dashboard-btn cursor-pointer" shortcut [shortcutNumList]="true" (click)="cart.startApplication(true)" [matTooltip]="'tooltip.entryRegister' | translate">
                <fa-icon icon="arrow-right-to-bracket"></fa-icon>
                {{'entry.register' | translate}}</div>
            </ng-container>
            <ng-container *ngIf="hasUiPerm(UiPermission.SHOW_QR_SCANNER_BTN)">
              <div class="dashboard-btn cursor-pointer" shortcut [shortcutNumList]="true" (click)="clickScan()" [matTooltip]="'tooltip.Qr' | translate">
                <fa-icon icon="qrcode"></fa-icon>
                {{'scan.applicationQr' | translate}}</div>
            </ng-container>

            <ng-container *ngIf="api.hasPerm(api.perm.ALLOW_CONTROL) && api.checkSeniority() > 0 && api.env.hasPrepareLandingVisa">
              <div class="dashboard-btn cursor-pointer" *ngIf="api.hasPerm(api.perm.ALLOW_CREATE)" shortcut [shortcutNumList]="true" (click)="cart.startApplication(true, undefined, undefined, undefined, true)" [matTooltip]="'tooltip.prepareLandingVisa' | translate">
                <fa-icon icon="plane-arrival"></fa-icon>
                {{'tooltip.prepareLandingVisa' | translate}}</div>
            </ng-container>

            <ng-container>
              <div class="dashboard-btn cursor-pointer" shortcut [shortcutNumList]="true" (click)="nav.to('admin-request')" [matTooltip]="'tooltip.searchManually' | translate">
                <fa-icon icon="magnifying-glass"></fa-icon>
                {{'search.manually' | translate}}</div>
            </ng-container>

            <ng-container *ngIf="showNextApplicationButton()">
              <div class="dashboard-btn cursor-pointer" shortcut [shortcutNumList]="true" (click)="nextApplication()" [matTooltip]="'tooltip.nextApplication' | translate">
                <fa-icon icon="arrow-right"></fa-icon>
                {{'nextApplication.button' | translate}}</div>
            </ng-container>

            <ng-container *ngIf="api.hasPerm(api.perm.ALLOW_CONSUME) && (api.isElectronApp || !!api.devtoolFakePassport) && scanDocument.consumeMode && !api.checkSeniority()">
              <div class="dashboard-btn cursor-pointer" [shortcut]="ShortcutAction.ENTER" (click)="scanDocument.scanPassport()" [matTooltip]="'tooltip.scanPassport' | translate">
                <fa-icon icon="passport"></fa-icon>
                {{'dropdown.pass' | translate}}</div>
            </ng-container>

            <ng-container *ngIf="api.hasPerm(api.perm.ALLOW_ADMIN)">
              <div class="dashboard-btn dashboard-btns-hidden cursor-pointer" (click)="!api.isOnline ? offlineLoader() : nav.to('places')" shortcut [shortcutNumList]="true"  [matTooltip]="api.env.type === DocumentType.ZWEVISA ? ('tooltip.Qr' | translate) : ''">
                <fa-icon icon="location-dot"></fa-icon>
                {{'menu.places' | translate}}</div>
            </ng-container>

            <ng-container *ngIf="api.hasPerm(api.perm.ALLOW_ADMIN)">
              <div class="dashboard-btn cursor-pointer" shortcut [shortcutNumList]="true" (click)="nav.to('users')">
                <fa-icon icon="users"></fa-icon>
                {{'menu.users' | translate}}</div>
            </ng-container>

            <ng-container *ngIf="!api.userRole?.isKiosk">
              <div class="dashboard-btn cursor-pointer" shortcut [shortcutNumList]="true" (click)="nav.to('my-account')" [matTooltip]="'tooltip.my_account' | translate">
                <fa-icon icon="gear"></fa-icon>
                {{'dashboard.my_account' | translate}}</div>
            </ng-container>

            <ng-container>
              <div class="dashboard-btn cursor-pointer" (click)="disconnect()" shortcut [shortcutNumList]="true" [matTooltip]="'tooltip.signout' | translate">
                <fa-icon class="icon-disconnect" icon="user-large-slash"></fa-icon>
                {{'global.signout' | translate}}</div>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="!api.userRole?.isKiosk && api.userRole.isCustomer">
          <app-slide-element leftIcon="gear" class="mt_10" (btnClicked)="nav.to('my-account')" [matTooltip]="'tooltip.my_account' | translate">{{'dashboard.my_account' | translate}}</app-slide-element>
        </ng-container>
      </div>
    </div>
  </div>
</div>
